import { render } from "./SectionComponent.vue?vue&type=template&id=3674ad7a&scoped=true&ts=true"
import script from "./SectionComponent.vue?vue&type=script&lang=ts"
export * from "./SectionComponent.vue?vue&type=script&lang=ts"

import "./SectionComponent.vue?vue&type=style&index=0&id=3674ad7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3674ad7a"]])

export default __exports__